import { useTranslation } from 'react-i18next'
import { Wrapper } from '@/features/Application/elements'
import { showInfoModal, getModalInfo } from '@/features/Application/info-modal'
import { SectionTitle } from '@/features/Application/elements'
import ViewComponent from './view-component'
import EmptyViewComponent from './empty'
import CreditSummaryBar from './credit-summary-bar'

const CreditSummaryView = ({ data = {}, application, isLocked, isLoading, standalone }) => {
  const { t } = useTranslation()

  const title = t('l.application.view.credit_summary.link', 'Credit Summary')

  const { title: modalTitle, content } = getModalInfo('credit-summary', t)
  const handleClick = () =>
    showInfoModal({
      title: modalTitle,
      content,
      isPoweredByEquifax: true
    })
  const showEmptyView =
    application?.trust_score?.status === 'not_enough_info' ||
    (application?.trust_score?.status === 'no_credit_history' && !isLocked) ||
    data?.status === 'not_enough_info' ||
    data?.status === 'no_credit_history'

  const isFailed = standalone
    ? data?.status === 'failed'
    : application?.trust_score?.status === 'failed'

  return (
    <Wrapper id="credit-summary">
      <SectionTitle
        title={title}
        handleInfoClick={handleClick}
        clickId="application-trust-score-info-credit"
        showInfo
        score={data?.score}
        maxScore={data?.max_score}
        rate={data?.rate}
        isLocked={isLocked}
        isLoading={isLoading}
      />
      {showEmptyView || isFailed ? (
        <>
          <CreditSummaryBar data={data} isLocked={true} isLoading={isLoading} />
          {!isLocked && (
            <EmptyViewComponent
              data={data}
              application={application}
              isLocked={isLocked}
              isLoading={isLoading}
              standalone={standalone}
            />
          )}
        </>
      ) : (
        <ViewComponent
          data={data}
          application={application}
          isLocked={isLocked}
          isLoading={isLoading}
        />
      )}
    </Wrapper>
  )
}

export default CreditSummaryView
